import { AppState } from '../index';
import * as fromRouter from '@ngrx/router-store';
import { createSelector } from '@ngrx/store';

export const selectRouter = (state: AppState) => state.router;

export const {
    selectCurrentRoute,   // select the current route
    selectFragment,       // select the current route fragment
    selectQueryParams,    // select the current route query params
    selectQueryParam,     // factory function to select a query param
    selectRouteParams,    // select the current route params
    selectRouteParam,     // factory function to select a route param
    selectRouteData,      // select the current route data
    selectUrl,            // select the current url
} = fromRouter.getRouterSelectors(selectRouter);

export const selectRouteParamDeep = (param: string) =>
    createSelector(selectRouter, (router) => {
        let route = router?.state?.root;
        while (route) {
            if (route.params?.[param]) {
                return route.params[param];
            }
            route = route.firstChild;
        }
        return undefined;
    });

export const selectRouteDataParam = (key: string) =>
    createSelector(
        selectRouter,
        (state) => {
            let r = state?.state?.root;
            while (r) {
                if (r.data?.[key] != null) { return r.data[key]; }
                r = r.firstChild;
            }
            return undefined;
        }
    );
